import React from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { setStatus } from '../../cart/cartSlice';
import Link from 'next/link';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import styles from '../../styles/header/Navbar.module.scss';
import { v4 as uuidv4 } from 'uuid';
import CartItemInfo from './CartItemInfo';

const CartTab = (props) => {
    const {cart} = props;

    const router = useRouter();
    const dispatch = useDispatch();

    const cartIcon = 
    <>
        <FontAwesomeIcon icon={faShoppingCart} height="16" width="16" className={styles.cartSize}/>
        {cart.length>0 && <Badge pill className={styles.cartBadge}>{cart.length}</Badge>}
    </>;

    const goToCart = (e) => { dispatch(setStatus('init')); router.push('/cart/')} 

    const cartList =     
        <DropdownButton 
            title={cartIcon} 
            drop="down" 
            variant="link" 
            className={`order-1 order-lg-3 me-2 ${styles.dropCart} d-none d-md-block`}
            menuAlign="right"
        >
            {cart.length > 0 ?
            <>
                {cart.map((item, k) =>{
                    return ( 
                        <React.Fragment key={uuidv4()} >
                            { k>0 && <Dropdown.Divider  />}
                            <Dropdown.Item as="div"  >
                                <CartItemInfo  product={item} />
                            </Dropdown.Item>
                        </ React.Fragment>
                    )}
                )}
                <Dropdown.Divider key={uuidv4()} />
                <Dropdown.Item as="button" onClick={goToCart} className={`text-center ${styles.showCart}`} >
                    Vezi cosul
                    <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="ms-2"/> 
                </Dropdown.Item>
            </>
            :
            <Dropdown.Item as="div" >Cosul este gol.</Dropdown.Item>
            }
           
        </ DropdownButton>;

    const cartListMobile = 
        <Link
            href="/cart"
            title="Cos cumparaturi"
            className={`d-block d-md-none ${styles.dropCart} me-4`}>

            <FontAwesomeIcon icon={faShoppingCart} height="16" width="16" className={styles.cartSize}/>
            {cart.length>0 && <Badge pill className={styles.cartBadge}>{cart.length}</Badge>}

        </Link>;

    

    return (
        <>
            {cartList}
            {cartListMobile}
        </>
       
    );
}

export default CartTab;